import React, { forwardRef, ReactNode } from 'react';
import { Box, BoxProps } from '@mui/material';
import { HeaderContainer, HeaderTitle, NewHeaderTitle } from '../style';

export interface CarouselHeaderProps extends Omit<BoxProps, 'title'> {
  title?: ReactNode;
  icon?: ReactNode;
  children?: ReactNode;
  newHeader?: boolean;
  titleName?: string;
}

const CarouselHeader = forwardRef<HTMLDivElement, CarouselHeaderProps>((props, ref) => {
  const { title, newHeader, titleName, children, ...boxProps } = props;
  return (
    <HeaderContainer ref={ref} data-testid="carousel-header-base-container" {...boxProps}>
      {newHeader ? (
        <NewHeaderTitle component="div" data-testid="carousel-header-title">
          {titleName}
        </NewHeaderTitle>
      ) : (
        <>
          {title && (
            <HeaderTitle variant="h6" component="div" data-testid="carousel-header-title">
              {title}
            </HeaderTitle>
          )}
        </>
      )}

      {children && <Box data-testid="carousel-header-children">{children}</Box>}
    </HeaderContainer>
  );
});

export default CarouselHeader;
